import React from "react";
import { getOrderStatusVariant } from "./statusUtils";
import "./ui.css";

function OrderStatus({
  status,
  children,
  className = "",
  uppercase = true,
  ...rest
}) {
  const variant = getOrderStatusVariant(status);
  const label = children ?? status ?? "";

  const classes = [
    "oh-order-status",
    `oh-order-status--${variant}`,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const displayLabel = uppercase && typeof label === "string"
    ? label.toUpperCase()
    : label;

  return (
    <span className={classes} {...rest}>
      {displayLabel}
    </span>
  );
}

export default OrderStatus;
